import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withFASDefaultRoute } from './withFASDefaultRoute';
import ChemHeader from '../ChemHeader';
import Confirm from '../Confirm';
import TreeMenu from '../TreeMenu';
import Restricted from '../Restricted';
import Help from './Help';
import Home from './Home';
import UserHome from './UserHome';
import AdminHome from './AdminHome';
import Applications from './Applications';
import Application from './Application';
import Users from './Users';
import User from './User';
import Groups from './Groups';
import Group from './Group';
import Rates from './Rates';
import Requests from './Requests';
import Microrequest from './Microrequest';
import AddRequest from './AddRequest';
import OrderHistory from './OrderHistory';
import Administrator from './Administrator';
import CHNAQueue from './CHNAQueue';
import CHNQueue from './CHNQueue';

class FAS extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var adminCanEdit = false;
		if (props.user && props.user.fas) {
			adminCanEdit = props.user.fas.adminLevel !== 7;
		}

		this.state = {
			fullScreen: false,
			groupEditable: false,
			userEditable: false,
			applicationEditable: false,
			requestEditable: false,
			treeMenuItems: this.filterTreeMenuItems(props.user),
			requestSearch: {
				ID: '',
				NAME: '',
				REQUESTDATE_FROM: null,
				REQUESTDATE_TO: null,
				DATECOMP_FROM: null,
				DATECOMP_TO: null,
				BILLINGDATE: null,
				STATUS: [],
				DELETE_FLAG: 'N',
				treeMenuClickCount: 1
			},
			adminCanEdit: adminCanEdit,
			confirm: ''
		};
	}
		
	componentDidUpdate(prevProps) {
		// if permissions have been populated
		if (!this.objectsAreEqual(prevProps.user, this.props.user)) {
			// update admin edit permission
			var adminCanEdit = false;
			if (this.props.user && this.props.user.fas) {
				adminCanEdit = this.props.user.fas.adminLevel !== 7;
			}
			
			// update user in state
			this.mergeStateWithArrays({
				treeMenuItems: this.filterTreeMenuItems(this.props.user),
				adminCanEdit: adminCanEdit
			});			
		}
	}
	
	filterTreeMenuItems(user) {
		// copy menu items so we can edit
		var filteredTreeMenuItems = this.copyTreeMenuItems(treeMenuItems);
		
		// if the user is not a fas admin
		if (!user.fas || user.fas.authLevel !== 1) {
			// remove all admin functions
			this.removeRoute(filteredTreeMenuItems, routes.groups);
			this.removeRoute(filteredTreeMenuItems, routes.users);
			this.removeRoute(filteredTreeMenuItems, routes.rates);
			this.removeRoute(filteredTreeMenuItems, routes.applications);
			this.removeRouteByLabel(filteredTreeMenuItems, 'All Requests');
			this.removeRouteByLabel(filteredTreeMenuItems, 'Postponed');
			this.removeRouteByLabel(filteredTreeMenuItems, 'Unarchived < 60 Days');
			this.removeRouteByLabel(filteredTreeMenuItems, 'Export & Archive');
		}
		
		// if user is not a regular user
		if (!user.fas || user.fas.authLevel === 0 || user.fas.authLevel === 1) {
			// remove "regular user" menu items
			this.removeRouteByLabel(filteredTreeMenuItems, 'New Request');
			this.removeRoute(filteredTreeMenuItems, routes.orderHistory);
		}
		
		// if user is neither a regular user nor an admin (i.e. not signed in yet)
		if (!user.fas || user.fas.authLevel === 0) {
			this.removeRouteByLabel(filteredTreeMenuItems, 'Edit Profile');
			this.removeRoute(filteredTreeMenuItems, routes.chnaQueue);
			this.removeRoute(filteredTreeMenuItems, routes.chnQueue);
		}
		
		return filteredTreeMenuItems;
	}

	removeRoute(menuItems, route) {
		for (var i = 0; i < menuItems.length; i++) {
			if (menuItems[i].nodes) {
				this.removeRoute(menuItems[i].nodes, route);
				if (menuItems[i].nodes.length === 0) {
					menuItems.splice(i--, 1);
				}
			} else {
				if (menuItems[i].route && menuItems[i].route.toUpperCase() === route.toUpperCase()) {
					menuItems.splice(i--, 1);
				}
			}
		}
	}
	
	removeRouteByLabel(menuItems, label) {
		for (var i = 0; i < menuItems.length; i++) {
			if (menuItems[i].nodes) {
				this.removeRouteByLabel(menuItems[i].nodes, label);
				if (menuItems[i].nodes.length === 0) {
					menuItems.splice(i--, 1);
				}
			} else {
				if (menuItems[i].label && menuItems[i].label.toUpperCase() === label.toUpperCase()) {
					menuItems.splice(i--, 1);
				}
			}
		}
	}
	
	showConfirmation(message) {
		var self = this;
		this.mergeState({
			confirm: message
		}, () => self.props.navigate('/FAS/Confirm'));
	}
	
	toggleFullScreen(fullScreen) {
		this.mergeState({ fullScreen: fullScreen });
	}
	
	onClickHome() {
		// if we are logged in as admin
		if (('' + this.props.user.uid).startsWith('fas.admin.') ||
			(this.props.user.fas && this.props.user.fas.authLevel === 1)) {
			// go to admin home page
			this.props.navigate(routes.adminHome);
		} else if (('' + this.props.user.uid).startsWith('fas.user.') ||
			(this.props.user.fas && this.props.user.fas.authLevel > 1)) {
			// go to user home page
			this.props.navigate(routes.userHome);
		} else {
			// go to login page
			this.props.navigate(routes.home);
		}
	}
	
	onClickAllRequests() {
		this.onRequestSearch({
			ID: '',
			NAME: '',
			REQUESTDATE_FROM: null,
			REQUESTDATE_TO: null,
			DATECOMP_FROM: null,
			DATECOMP_TO: null,
			BILLINGDATE: null,
			COMPLETE: null,
			STATUS: [],
			DELETE_FLAG: 'N',
			treeMenuClickCount: this.state.requestSearch.treeMenuClickCount + 1
		});
	}
	
	onClickPostponed() {
		this.onRequestSearch({
			ID: '',
			NAME: '',
			REQUESTDATE_FROM: null,
			REQUESTDATE_TO: null,
			DATECOMP_FROM: null,
			DATECOMP_TO: null,
			BILLINGDATE: null,
			COMPLETE: null,
			STATUS: ['Postponed'],
			DELETE_FLAG: 'N',
			treeMenuClickCount: this.state.requestSearch.treeMenuClickCount + 1
		});
	}
	
	onClickUnarchived() {
		// start with last 60 days
		var from60Days = new Date();
		from60Days.setDate(from60Days.getDate() - 60);

		this.onRequestSearch({
			ID: '',
			NAME: '',
			REQUESTDATE_FROM: null,
			REQUESTDATE_TO: null,
			DATECOMP_FROM: this.dateTimeToMVC(from60Days),
			DATECOMP_TO: null,
			BILLINGDATE: null,
			COMPLETE: null,
			STATUS: ['Saved','Submitted','Updated','Completed'],
			DELETE_FLAG: 'N',
			treeMenuClickCount: this.state.requestSearch.treeMenuClickCount + 1
		});
	}
	
	onClickExport() {
		this.onRequestSearch({
			ID: '',
			NAME: '',
			REQUESTDATE_FROM: null,
			REQUESTDATE_TO: null,
			DATECOMP_FROM: null,
			DATECOMP_TO: null,
			BILLINGDATE: 'NOTBILLED',
			COMPLETE: 1,
			STATUS: [],
			DELETE_FLAG: 'N',
			treeMenuClickCount: this.state.requestSearch.treeMenuClickCount + 1
		});
	}
	
	onClickNewRequest() {
		if (('' + this.props.user.uid).startsWith('fas.user.')) {
			this.props.navigate('/FAS/Microrequests/new/' + this.props.user.uid.substring(9));
		} else {
			this.showAlert('System Error', 'User ID not found.');
		}
	}
	
	onClickEditProfile() {
		if (('' + this.props.user.uid).startsWith('fas.user.')) {
			this.props.navigate('/FAS/Users/' + this.props.user.uid.substring(9));
		} else if (('' + this.props.user.uid).startsWith('fas.admin.')) {
			this.props.navigate('/FAS/Administrators/' + this.props.user.uid.substring(10));
		} else {
			this.showAlert('System Error', 'Admin ID or User ID not found.');
		}
	}
	
	onRequestSearch(requestSearch) {
		var self = this;
		this.mergeState({
			requestSearch: requestSearch
		}, () => {
			if (self.props.match.path !== routes.requests) {
				self.props.navigate(routes.requests);
			}
		});
	}

	render() {
		return (<>
			<ChemHeader parent={this} user={this.props.user} title='MicroAnalytical Lab Requests' fullScreen={this.state.fullScreen} 
				toggleFullScreen={(fullScreen) => this.toggleFullScreen(fullScreen)}
				showHelp={() => this.props.navigate('/FAS/Help', { helpPath: this.props.location.pathname })} />
			<Container fluid style={{ paddingTop: 20, paddingBottom: 20, backgroundColor: '#e6e6e4', height: 'calc(100vh - 64px)', overflow: 'auto' }}>
				<Row>
					{!this.state.fullScreen && <Col xs={2}>
						<TreeMenu parent={this} menuItems={this.state.treeMenuItems} selectedRoute={this.props.location.pathname} />
					</Col>}
					<Col xs={this.state.fullScreen ? 12 : 10}>
					  <main id='main'>
						<Routes>
							<Route path={'/confirm'} element={<Confirm parent={this} user={this.props.user} message={this.state.confirm} />} />
							<Route path={'/help'} element={<Help parent={this} user={this.props.user} />} />
							<Route path={'/home'} element={<Home parent={this} user={this.props.user} logIn={(action, username, password, fnSuccess) => 
								this.props.logIn(JSON.stringify({ Action: action, Username: username, Password: password }), fnSuccess)} />} />
							<Route path={'/userhome'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel > 0}>
									<UserHome parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/adminhome'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<AdminHome parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/groups'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<Groups parent={this} user={this.props.user} editable={this.state.adminCanEdit}
										setGroupEditable={(groupEditable) => this.mergeState({ groupEditable: groupEditable })} />
								</Restricted>
							} />							
							<Route path={'/groups/new'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<Group parent={this} user={this.props.user} editable={true} />
								</Restricted>
							} />							
							<Route path={'/groups/:groupId'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<Group parent={this} user={this.props.user} editable={this.state.groupEditable} />
								</Restricted>
							} />							
							<Route path={'/users'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<Users parent={this} user={this.props.user} editable={this.state.adminCanEdit}
										setUserEditable={(userEditable) => this.mergeState({ userEditable: userEditable })} />
								</Restricted>
							} />
							<Route path={'/users/:userId'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel > 0}>
									<User parent={this} user={this.props.user} editable={this.state.userEditable} />
								</Restricted>
							} />
							<Route path={'/administrators/:adminId'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<Administrator parent={this} user={this.props.user} editable={this.state.adminCanEdit} />
								</Restricted>
							} />
							<Route path={'/rates'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<Rates parent={this} user={this.props.user} editable={this.state.adminCanEdit} />
								</Restricted>
							} />
							<Route path={'/applications'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<Applications parent={this} user={this.props.user} editable={this.state.adminCanEdit}
										setApplicationEditable={(applicationEditable) => this.mergeState({ applicationEditable: applicationEditable })} />
								</Restricted>
							} />
							<Route path={'/applications/:appId'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<Application parent={this} user={this.props.user} editable={this.state.applicationEditable} />
								</Restricted>
							} />
							<Route path={'/requests'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<Requests parent={this} user={this.props.user} search={this.state.requestSearch} editable={this.state.adminCanEdit}
										setRequestEditable={(requestEditable) => this.mergeState({ requestEditable: requestEditable })}/>
								</Restricted>
							} />
							<Route path={'/microrequests/:requestId'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel > 0}>
									<Microrequest parent={this} user={this.props.user} editable={this.state.requestEditable} />
								</Restricted>
							} />
							<Route path={'/microrequests/new/:userId'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel > 0}>
									<Microrequest parent={this} user={this.props.user} editable={true} />
								</Restricted>
							} />
							<Route path={'/addrequest'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel === 1}>
									<AddRequest parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/orderhistory'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel > 1}>
									<OrderHistory parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/chnaqueue'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel > 0}>
									<CHNAQueue parent={this} user={this.props.user} />
								</Restricted>
							} />
							<Route path={'/chnqueue'} element={
								<Restricted authorized={this.props.user.fas && this.props.user.fas.authLevel > 0}>
									<CHNQueue parent={this} user={this.props.user} />
								</Restricted>
							} />
						</Routes>
					  </main>
					</Col>
				</Row>
			</Container>
		</>);
	}
}

// routes defined here so there are no accidents when removing them!
const routes = {
	adminHome: '/FAS/AdminHome',
	applications: '/FAS/Applications',
	chnaQueue: '/FAS/CHNAQueue',
	chnQueue: '/FAS/CHNQueue',
	groups: '/FAS/Groups',
	home: '/FAS/Home',
	orderHistory: '/FAS/OrderHistory',
	rates: '/FAS/Rates',
	requests: '/FAS/Requests',
	userHome: '/FAS/UserHome',
	users: '/FAS/Users'
};

const treeMenuItems = [
	{
		label: 'Home',
		onClick: props => props.parent.onClickHome()
	},
	{
		label: 'Groups',
		route: routes.groups
	},
	{
		label: 'Users',
		route: routes.users
	},
	{
		label: 'Rates',
		route: routes.rates
	},
	{
		label: 'Applications',
		route: routes.applications
	},
	{
		label: 'Recharge Requests',
		nodes: [
			{
				label: 'All Requests',
				onClick: props => props.parent.onClickAllRequests()
			},
			{
				label: 'Postponed',
				onClick: props => props.parent.onClickPostponed()
			},
			{
				label: 'Unarchived < 60 Days',
				onClick: props => props.parent.onClickUnarchived()
			},
			{
				label: 'Export & Archive',
				onClick: props => props.parent.onClickExport()
			}
		]
	},
	{
		label: 'New Request',
		onClick: props => props.parent.onClickNewRequest()
	},
	{
		label: 'Edit Profile',
		onClick: props => props.parent.onClickEditProfile()
	},
	{
		label: 'Order History',
		route: routes.orderHistory
	},
	{
		label: 'CHN (air-sensitive) and CHNS (air-sensitive) Queue',
		route: routes.chnaQueue
	},
	{
		label: 'CHN and CHNS Queue',
		route: routes.chnQueue
	}
];

export default withFASDefaultRoute(FAS);
